import moment from 'moment';
import { capitalize } from 'lodash';

import { formatPhoneNumber } from './format-phone-number';

export const formatAppointmentToCalendar = (appointments) =>
  appointments.map((appointment) => {
    const {
      uuid,
      start_date: startDate,
      end_date: endDate,
      relationShips,
    } = appointment;
    const { participant, service, clinic } = relationShips;
    const {
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      city,
      state,
      country,
      custome_field_name: customFieldName,
      custom_field_value: customFieldValue,
    } = participant[0] || {};
    const { name: serviceName, default_duration: defaultDuration } =
      service[0] || {};
    const {
      id: clinicId,
      startDate: clinicStartDate,
      sublocation_id: subLocationId,
      organization_id: organizationId,
    } = clinic[0] || {};

    const start = moment(startDate, 'YYYY-MM-DD hh:mm:ss').toDate();
    const end = moment(endDate, 'YYYY-MM-DD hh:mm:ss').toDate();

    return {
      start,
      end,
      allDay: false,
      resources: {
        uuid,
        timeSlot: moment(startDate).format('h:mma'),
        fullName: `${capitalize(firstName)} ${capitalize(lastName)}`,
        participant: {
          phone: formatPhoneNumber(phone),
          email,
          city,
          state,
          country,
          customFieldName,
          customFieldValue,
        },
        clinic: {
          clinicId,
          subLocationId,
          organizationId,
          startDate: moment(clinicStartDate).format('MMM D, YYYY'),
        },
        service: {
          serviceName,
          defaultDuration,
        },
      },
    };
  });
